import React, { PropsWithChildren } from 'react';

import { EntityType, ProductUpdate, EntityUpdate } from '../taskAuthorizations';
import { DefaultChangesList } from './default-change-list';
import { ProductChangesList } from './product-change-list';
import { ProductPriceVersionChangeList } from './product-price-version-change-list';

interface Props {
    entityType: EntityType;
    updates: EntityUpdate[] | ProductUpdate[];
    entityId?: string;
    title?: string[];
}

export function ChangesListRenderer({ entityType, updates, entityId, title }: PropsWithChildren<Props>) {
    switch (entityType) {
        case EntityType.productManagement:
            return <ProductChangesList updates={updates} />;
        case EntityType.productPriceVersion:
            return (
                <ProductPriceVersionChangeList
                    entityId={entityId}
                    groupName={title && title.length ? title[0] : undefined}
                    updates={updates as EntityUpdate[]}
                />
            );
        default:
            return <DefaultChangesList entityId={entityId} updates={updates as EntityUpdate[]} />;
    }
}
